import { Button } from '@shared/components';
import { PermissionGuard } from '@/features/auth';

interface Props {
    onClick: () => void;
}

export function ReverseInvoiceButton({ onClick }: Props) {
    return (
        <PermissionGuard permission={{ resource: 'invoice', action: 'reverse' }}>
            <Button type="button" size="sm" variant="danger" appearance="outline" onClick={onClick}>
                Reverse invoice
            </Button>
        </PermissionGuard>
    );
}
